import * as React from 'react';
var AccordionContext = React.createContext({
  disabled: false,
  isExpanded: false,
  onToggle: function onToggle() {}
});
export default AccordionContext;